import { render, staticRenderFns } from "./p14.vue?vue&type=template&id=6b97b728&scoped=true&"
import script from "./p14.vue?vue&type=script&lang=js&"
export * from "./p14.vue?vue&type=script&lang=js&"
import style0 from "./p14.vue?vue&type=style&index=0&id=6b97b728&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b97b728",
  null
  
)

export default component.exports